<template>
    <layout title="Customer Aging Report">
        <div class="px-8">
            <customer-statement-display :statement="statement"></customer-statement-display>
        </div>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import CustomerStatementDisplay from "@/Components/CustomerStatements/CustomerStatementDisplay";

export default {
    components: {CustomerStatementDisplay, Layout},
    props: {
        statement: {
            type: Object,
            default: {}
        },
    },
}
</script>
